module.exports = __webpack_public_path__ + "media/images/lp_v6_sec12-fd4912cdad6ad08efeba3e1260b6bc44.png";